export default __webpack_public_path__ + "static/media/navbar-statistics-hlr-orange.a3a818e5.svg";